export default __webpack_public_path__ + "static/media/Larry Klein.c5f6b3a1.jpg";